import { safeAtob } from "./enode-decode-string";

export function dataUrlToFile(dataUrl: any, filename: any) {
  if (dataUrl) {
    const [mimeType, base64Data] = dataUrl.split(",");
    const binaryData = base64Data ? safeAtob(base64Data) : null;

    if (!binaryData) return;

    const arrayBuffer = new ArrayBuffer(binaryData?.length);
    const uint8Array = new Uint8Array(arrayBuffer);
    for (let i = 0; i < binaryData?.length; i++) {
      uint8Array[i] = binaryData?.codePointAt(i) ?? 0;
    }

    const blob = new Blob([arrayBuffer], { type: mimeType });
    const file = new File([blob], filename, { type: mimeType });
    return file;
  }

  return undefined;
}
